import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';

import {LogService} from './log.service';

import {JwtHelper} from 'angular2-jwt';


@Injectable()
export class AuthExistsGuard implements CanActivate {
	constructor(
		private router: Router,

		private log: LogService
	) {}


	jwtHelper: JwtHelper = new JwtHelper();


	canActivate() {
		if (!window.localStorage) {
			this.log.warn('AuthExistsGuard, Browser does not support local storage.');
// TODO!!! - fix this
			// alert('Authentication Missing.  No Local Storage');
			this.router.navigate(['site/home']);
			return false;
		}

		let authJwt = localStorage.getItem('auth-jwt');
		if (!authJwt) {
			this.log.warn('AuthExistsGuard, auth-jwt missing from local storage.');
// TODO!!! - fix this
			// alert('Authentication Missing.');
			this.router.navigate(['site/home']);
			return false;
		}

		let expireDate = this.jwtHelper.getTokenExpirationDate(authJwt);
		// console.log('local jwt expires = ' + expireDate);
		if (new Date() > expireDate) {
			this.log.warn('AuthExistsGuard, auth-jwt from local storage has expired.  expireDate = ' + expireDate);
// TODO!!! - fix this
			// alert('Authentication Expired.');
			return false;
		}

		return true;
	}

}





/*

@Injectable()

export class AuthGuard implements CanActivate {

auth: any = {};

constructor(private authService: AuthService, private router: Router) {

}

canActivate() {
    if (user is logged in) {
        this.router.navigate(['/dashboard']);
        return true;
    }
    else {
        this.router.navigate(['/Login']);
    }
    return false;
}
}


*/



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/auth-exists-guard.service.ts